export default "__VITE_ASSET__CHz5ChGC__"